<template>
  <div class="price">
    <span class="price-int"
      >{{ $t("common.currency") }}{{ price | priceInt }}</span
    >
    <span class="price-float">{{ price | priceFloat }}</span>
    <span v-if="unit" style="color: #333">/{{ unit  }}</span>
    <span
      class="price-lose"
      v-if="!isShowDiscount && losePrice && price !== losePrice"
      >{{ $t("common.currency") }}{{ losePrice.toFixed(2) }}</span
    >
    <div class="price-tag" v-if="isShowDiscount">
      {{ formartDiscount() }}
    </div>
  </div>
</template>

<script>
import { mul } from "@/utils/numberComputed";
export default {
  props: {
    price: {
      type: Number,
      default: 0,
    },
    losePrice: {
      type: Number,
      default: 0,
    },
    discountRate: {
      type: Number,
      default: 1,
    },
    unit: {
      type: String,
      default: '',
    },
  },
  computed: {
    isShowDiscount() {
      return this.discountRate && this.discountRate !== 1;
    },
  },
  filters: {
    priceInt(value) {
      if (!value) {
        return 0;
      }
      return String(value).split(".")[0];
    },
    priceFloat(value) {
      if (!value || !(value + "").includes(".")) {
        return ".00";
      }
      return "." + String(value).split(".")[1].slice(0, 2);
    },
  },

  methods: {
    formartDiscount() {
      const num = mul(this.discountRate, 100);
      if (num % 10 === 0) {
        return num / 10 + "折";
      } else {
        return num + "折";
      }
    },
    pricePoint(value) {
      if (!value) {
        return this.fixedNum === 2 ? ".00" : ".0000";
      }
      function padDecimal(num, digits) {
        // 转换为字符串
        var str = num.toString();
        // 分割整数部分和小数部分
        var parts = str.split(".");
        // 如果小数部分不足指定位数，补0
        while (parts[1] && parts[1].length < digits) {
          parts[1] += "0";
        }
        return `.${parts[1].substring(0, digits)}`;
      }
      if (String(value).split(".")[1]) {
        return padDecimal(String(value), this.fixedNum);
      } else {
        return this.fixedNum === 2 ? ".00" : ".0000";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.price {
  font-family: Alibaba PuHuiTi;
}
.price-lose {
  display: inline-block;
  padding-left: 4px;
  color: #999;
  font-size: 12px;
  text-decoration: line-through;
}
.price-tag {
  display: inline-block;
  width: 68px;
  height: 26px;
  position: relative;
  top: 0px;
  background-image: url("../../assets/img/good/price-tag-bg.png");
  color: #fff;
  font-size: 12px;
  text-align: center;
  padding-left: 28px;
  line-height: 26px;
}
</style>
